<template>
  <div class="tab-pane fade in active" v-scroll>
    <p v-show="nothing">未搜索到文件夹</p>
    <p v-show="total">搜索到{{ total }}个文件夹</p>
    <div class="searchlist" v-for="file in files" :key="file.number">
      <div class="file-icon">
        <svg aria-hidden="true" class="icon">
          <use
            :xlink:href="
              '#icon-' + getIcon(file.type, file.file_type, file.file_ext)
            "
          />
        </svg>
      </div>
      <div class="cont">
        <div class="name">
          <a @click="goToFolder(file)" :title="file | formatData">{{
            file | formatData
          }}</a>
          <span class="time">已于{{ file.last_update_date }}修改</span>
        </div>
        <div class="path" :title="file.position" @click="goToFolder(file)">
          {{ file.position }}
        </div>
      </div>
    </div>
    <div class="scroll-loading" v-show="loading">正在加载中...</div>
    <SearchFilter
      ref="search-filter"
      searchType="folder"
      :showFirstLevelFolder="showFirstLevelFolder"
      :firstLevelFolders="firstLevelFolders"
      @searchByFilter="searchByFilter"
      @hideFirstLevelFolder="hideFirstLevelFolder"
      :msg5021="msg5021"
    ></SearchFilter>
  </div>
</template>

<script>
import { formatData, positionFilter } from "@/utils/index";
import { getIcon } from "@/utils/icon";
import { getGroups } from "@/api/group/group";
import { resourceSearch } from "@/api/drive/drive";
export default {
  name: "Search",
  components: {
    SearchFilter: () => import("./SearchFilter"),
  },
  data() {
    return {
      loading: false,
      nothing: false,
      total: 0, // 列表总数
      query: {
        group_number: "",
        category: "folder",
        searchName: null,
        disk_type: "cloud",
        offset: 0,
        limit: 21, // 每页数量
        search_start_date: "",
        search_end_date: "",
        first_level_folder: "",
      },
      firstLevelFolders: [],
      showFirstLevelFolder: false,
      msg5021: "",
      files: [],
      CachedGroups: [], // 暂未使用cache功能（因为可能在筛选的过程中，新增了群组，虽然可能性极小），cache功能：如果当前已经获取了群组列表，在下一次筛选时不重新获取群组
    };
  },
  created() {
    this.query.searchName = this.$route.query.search;
    this.search();
  },
  beforeRouteUpdate(to, from, next) {
    this.query.searchName = to.query.search;
    this.search();
    next();
  },
  filters: {
    formatData: formatData,
    positionFilter: positionFilter,
  },
  watch: {
    "query.searchName": {
      handler: function () {
        this.showFirstLevelFolder = false;
      },
    },
  },
  directives: {
    scroll: {
      bind: function (el, binding, vnode) {
        window.addEventListener("scroll", vnode.context.scrollLoad);
      },
      unbind: function (el, binding, vnode) {
        window.removeEventListener("scroll", vnode.context.scrollLoad);
      },
    },
  },
  methods: {
    scrollLoad() {
      let scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let bodyHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;
      let hh = scrollTop + window.innerHeight >= bodyHeight - 300;
      if (hh && this.query.offset < this.total - this.query.limit) {
        if (this.loading) {
          return false;
        } else {
          this.query.offset = this.query.offset + this.query.limit;
          this.search();
        }
      }
    },
    /**
     * 跳转到云盘/群盘文件
     */
    goToFolder(file) {
      let routeUrl;
      if (file.group_number) {
        routeUrl = this.$router.resolve({
          name: "groupDisk",
          params: {
            groupNumber: file.group_number,
          },
          query: {
            type: "file",
            number: file.parent_number,
          },
        });
      } else {
        routeUrl = this.$router.resolve({
          name: "recdrive",
          query: {
            tab: "file",
            number: file.parent_number,
            disk_type: file.disk_type,
          },
        });
      }
      window.open(routeUrl.href, "_blank");
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    hideFirstLevelFolder() {
      this.showFirstLevelFolder = false;
      this.query.first_level_folder = "";
      this.firstLevelFolders = [];
    },
    searchByFilter(query) {
      this.query.disk_type = query.disk_type;
      this.query.group_number = query.group_number;
      this.query.search_start_date = query.search_start_date;
      this.query.search_end_date = query.search_end_date;
      this.query.searchName = query.searchName;
      this.query.first_level_folder = query.first_level_folder;
      this.files = [];
      this.search();
    },
    search() {
      this.loading = true;
      this.resourceSearch();
    },
    resourceSearch() {
      if (!this.query.searchName) {
        this.loading = false;
        this.nothing = true;
        return false;
      }
      resourceSearch(this.query)
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.total = res.entity.total;
            if (res.entity.total) {
              this.nothing = false;
              this.getFilePath(res.entity.datas);
            } else {
              this.nothing = true;
              this.total = 0;
            }
          } else if (res.status_code === 5021) {
            this.total = 0;
            // 此处属于群文件搜索的时候，符合要求的文件数过多，要求选择一个一级文件夹
            this.firstLevelFolders = res.entity;
            this.query.first_level_folder = this.firstLevelFolders[0].id;
            this.$refs["search-filter"].changeFirstLevelFolder(
              this.firstLevelFolders[0].id
            );
            this.showFirstLevelFolder = true;
            this.msg5021 = res.message;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    getFilePath(datas) {
      getGroups({
        group_review: "adopt",
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (res.entity.total > 0) {
              this.CachedGroups = res.entity.datas;
              let files = datas.map((file) => {
                let path =
                  file.parent_number === "0"
                    ? "/"
                    : file.parent_path_name + "/";
                let ext = file.file_ext ? "." + file.file_ext : "";
                let group = this.CachedGroups.find(
                  (s) => s.group_number === file.group_number
                );
                if (group && group.group_name) {
                  file.position =
                    "群盘/" + group.group_name + path + file.name + ext;
                } else {
                  file.position = "云盘" + path + file.name + ext;
                }
                return file;
              });
              this.files = this.files.concat(files);
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
.scroll-loading {
  width: 100%;
  color: #006adf;
  text-align: center;
  line-height: 70px;
  height: 70px;
  /* background: #006adf; */
  float: left;
}
</style>